import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import Testimonials from "@/pages/admin/Testimonials";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/testimonials")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-testimonials", path: "/admin/testimonials", title: "Cloud Admin Testimonials", description: "Administrationsyta" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><Testimonials /></AdminLayout>,
});
